import React from "react";

function ItemisedMarginTable({ data }) {
  return (
    <>
      <div>
        {data.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th scope="col">S.NO.</th>
                <th scope="col">SYMBOL</th>
                <th scope="col">ISIN CODE</th>
                <th scope="col">SCRIP NAME</th>
                <th scope="col">SECURITY TYPE</th>
                <th scope="col">SERIES</th>
                <th scope="col">COLLATERAL TYPE</th>
                <th scope="col">CASH OR NON CASH</th>
                <th scope="col">CMP</th>
                <th scope="col">HAIRCUT</th>
                <th scope="col">PLEDGE TYPE</th>
                <th scope="col">DEBIT QTY</th>
                <th scope="col">UNPLEDGED DP HOLDING QTY</th>
                <th scope="col">NORMAL MARGIN PLEDGED QTY</th>
                <th scope="col">MTF MARGIN PLEDGED QTY</th>
                <th scope="col">MTF HOLDING QTY</th>
                <th scope="col">UNSETTLED QTY</th>
                <th scope="col">TOTAL QTY</th>
                <th scope="col">DEBIT VALUE</th>
                <th scope="col">UNPLEDGED DP HOLDING VALUE</th>
                <th scope="col">NORMAL MARGIN PLEDGED VALUE</th>
                <th scope="col">MTF MARGIN PLEDGED VALUE</th>
                <th scope="col">MTF HOLDING VALUE</th>
                <th scope="col">UNSETTLED VALUE</th>
                <th scope="col">TOTAL VALUE</th>
                <th scope="col">
                  TOTAL CASH COMPONENT FOR MARGIN REPORTING (BHC)
                </th>
                <th scope="col">
                  TOTAL CASH COMPONENT FOR LIMIT AND EXPOSURE (AHC)
                </th>
                <th scope="col">
                  TOTAL NON CASH COMPONENT FOR MARGIN REPORTING (BHC)
                </th>
                <th scope="col">
                  TOTAL NON CASH COMPONENT FOR LIMIT AND EXPOSURE (AHC)
                </th>
                <th scope="col">ADDITIONAL OPPORTUNITY TO TRADE</th>
              </tr>
            </thead>
            <tbody id="clientrevenue-scroll">
              {data.length > 0 &&
                data.map((item, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{item.symbol}</td>
                      <td>{item.isin_Code || "-"}</td>
                      <td>{item.scrip_Name || "-"}</td>
                      <td>{item.security_Type}</td>
                      <td>{item.series}</td>
                      <td>{item.collateral_Type || "-"}</td>
                      <td>{item.cash_Or_NonCash}</td>
                      <td>{item.current_Market_Price}</td>
                      <td>{item.hairCut}</td>
                      <td>{item.pledge_Type}</td>
                      <td>{item.debit_Qty}</td>
                      <td>{item.unPledged_DPHolding_Qty}</td>
                      <td>{item.normal_MarginPledged_Qty}</td>
                      <td>{item.mtf_MarginPledged_Qty}</td>
                      <td>{item.mtf_Holding_Qty}</td>
                      <td>{item.unsettled_Qty}</td>
                      <td>{item.total_Qty}</td>
                      <td>{item.debit_Value}</td>
                      <td>{item.unPledged_DPHolding_Value}</td>
                      <td>{item.normal_MarginPledged_Value}</td>
                      <td>{item.mtf_MarginPledged_Value}</td>
                      <td>{item.mtf_HoldingValue}</td>
                      <td>{item.unsettled_Value}</td>
                      <td>{item.total_Value}</td>
                      <td>
                        {item.total_Cash_Margin_BHC !== ""
                          ? item.total_Cash_Margin_BHC
                          : "-"}
                      </td>
                      <td>
                        {item.total_Cash_Limit_AHC !== ""
                          ? item.total_Cash_Limit_AHC
                          : "-"}
                      </td>
                      <td>
                        {item.total_NonCash_Margin_BHC === ""
                          ? "-"
                          : item.total_NonCash_Margin_BHC}
                      </td>
                      <td>
                        {item.total_NonCash_Limit_AHC === ""
                          ? "-"
                          : item.total_NonCash_Limit_AHC}
                      </td>
                      <td>
                        {item.additional_Trade_Opportunity === ""
                          ? "-"
                          : item.additional_Trade_Opportunity}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        ) : (
          ""
        )}
      </div>
    </>
  );
}
export default ItemisedMarginTable;
